import { ProtoButton } from '@/features/d0/states'
import { CHAPTERS } from './registry'
import { chapterRecord, type ChapterStatus, type TutorialState } from './machine'

const STATUS: Record<ChapterStatus, string> = {
  completed: 'Completed',
  skipped: 'Skipped',
  in_progress: 'In progress',
  paused: 'Paused',
  not_started: 'Not started',
}

// The guide-owned summary (tutorial-summary) with the replay list (tutorial-chapters).
export default function Summary({ state, onRestart }: { state: TutorialState; onRestart: (chapter: string) => void }) {
  const statuses = CHAPTERS.map((c) => chapterRecord(state, c.id).status)
  const count = (s: ChapterStatus) => statuses.filter((x) => x === s).length

  return (
    <section className="t0-summary" data-tutorial-anchor="tutorial-summary" aria-labelledby="t0-summary-title">
      <h3 className="t0-summary__title" id="t0-summary-title">Your progress</h3>
      <p className="t0-summary__counts">
        {count('completed')} completed · {count('skipped')} skipped · {count('not_started')} not started
      </p>
      <ol className="t0-summary__list" data-tutorial-anchor="tutorial-chapters">
        {CHAPTERS.map((c, i) => {
          const status = STATUS[statuses[i]]
          return (
            <li key={c.id} className="t0-summary__row" data-chapter={c.id} data-status={statuses[i]}>
              <span className="t0-summary__name">{c.title}</span>
              <span className="ui-pill">{status}</span>
              <ProtoButton className="z-quiet" onClick={() => onRestart(c.id)} aria-label={`Restart chapter: ${c.title}`}>
                Restart chapter
              </ProtoButton>
            </li>
          )
        })}
      </ol>
    </section>
  )
}
